import { lazy } from "react";
import {
  enumPermisosDepositosMasivo,
  enumPermisosDepositosMasivoOperaciones,
} from "./enumPermisosDepositosMasivos";

/** Componente de iconos */
const AppIcons = lazy(() => import("../../../components/Base/AppIcons"));
const DepositoMasivoComercios = lazy(() =>
  import("./Views/DepositoMasivoComercios")
);
const SearchDepositosMasivos = lazy(() =>
  import("./Views/SearchDepositosMasivos")
);
const SearchDepositosMasivosOperaciones = lazy(() =>
  import("./Views/SearchDepositosMasivosOperaciones")
);
const DepositosMasivosNav = lazy(() => import("./DepositosMasivosNav"));

const listPermissions = Object.values(enumPermisosDepositosMasivo);
export const listPermissionsDepositosMasivos = listPermissions;
export const listPermissionsDepositosMasivosOperaciones = Object.values(
  enumPermisosDepositosMasivoOperaciones
);

const rutasDepositosMasivos = {
  link: "/depositos-masivos",
  label: <AppIcons Logo={"RECAUDO_MULTIPLE"} name="Pago Masivo Billeteras" />,
  component: DepositosMasivosNav,
  permission: listPermissionsDepositosMasivos,
  subRoutes: [
    {
      link: "/depositos-masivos/transaccion-comercio",
      label: (
        <AppIcons Logo={"MARKETPLACE"} name="Cargar Pago Masivo Billeteras" />
      ),
      component: DepositoMasivoComercios,
      permission: [enumPermisosDepositosMasivo.DEPOSITO_MASIVO_CARGUE],
    },
    {
      link: "/depositos-masivos/consulta-paginada",
      label: (
        <AppIcons
          Logo={"RECAUDO_MULTIPLE_CONSULTAR_PAGINADO"}
          name="Consulta Pago Masivo Billeteras"
        />
      ),
      component: SearchDepositosMasivos,
      permission: [enumPermisosDepositosMasivo.DEPOSITO_MASIVO_CONSULTA],
    },
  ],
};
export const rutasDepositosMasivosOperaciones = {
  link: "/GestionTransaccional/depositos-masivos",
  label: <AppIcons Logo={"RECAUDO_MULTIPLE"} name="Pago Masivo Billeteras" />,
  component: DepositosMasivosNav,
  permission: listPermissionsDepositosMasivos,
  subRoutes: [
    {
      link: "/GestionTransaccional/depositos-masivos/consulta-paginada",
      label: (
        <AppIcons
          Logo={"RECAUDO_MULTIPLE_CONSULTAR_PAGINADO"}
          name="Consulta Pago Masivo Billeteras"
        />
      ),
      component: SearchDepositosMasivosOperaciones,
      permission: [
        enumPermisosDepositosMasivoOperaciones.DEPOSITO_MASIVO_CONSULTA_OPERACIONES,
      ],
    },
  ],
};
export default rutasDepositosMasivos;
